import service from '@/store/services/vendors/activity-skills-service';

const state = {
    list: {},
    activitySkill: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, activitySkill) => {
        state.activitySkill = activitySkill;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(activitySkill => {
                commit('SET_RESOURCE', activitySkill);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(activitySkill => {
                commit('SET_RESOURCE', activitySkill);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((activitySkill) => {
                commit('SET_RESOURCE', activitySkill);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((activitySkill) => {
                commit('SET_RESOURCE', activitySkill);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    activitySkill: state => state.activitySkill,
    url: state => state.url,
    dropdown: (state) => {
        return state.list.map(activitySkill => ({
            id: activitySkill.id,
            skill_id: activitySkill.skill_id,
            activity_id: activitySkill.activity_id,
        }));
    }
};

const activitySkills = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default activitySkills;
